import type { ActionCategory } from './types';

const CATEGORIES: ActionCategory[] = [
    {
        id: 'clinical',
        label: 'Clinical',
        description: 'Treatment, records, and patient-facing documents',
        order: 1
    },
    {
        id: 'vca',
        label: 'VCA',
        description: 'Workflow triggers for the VCA team',
        order: 2
    },
    {
        id: 'dm',
        label: 'Dental Monitoring',
        description: 'DM patient lifecycle, monitoring, and messaging',
        order: 3
    },
    {
        id: 'admin',
        label: 'Admin',
        description: 'Destructive operations — admins only',
        order: 99
    }
];

export { CATEGORIES };
